import { ApolloError, useMutation } from '@apollo/client'

import { FormReportInput, MutationSendFormsReportArgs } from '@types'

import { MUTATION_SEND_FORMS_REPORT } from '../../libs/apollo/mutations/report.mutation'

export const useSendReportForms = (): {
  sendFormsReport: (input: FormReportInput) => void
  loading: boolean
  error: ApolloError | undefined
} => {
  const [sendFormsReport, { loading, error }] = useMutation<void, MutationSendFormsReportArgs>(
    MUTATION_SEND_FORMS_REPORT,
    {
      notifyOnNetworkStatusChange: true,
    },
  )

  const _sendFormsReport = async (input: FormReportInput) => {
    try {
      await sendFormsReport({
        variables: {
          input,
        },
      })
    } catch (error) {
      console.error(error)
    }
  }

  return { sendFormsReport: _sendFormsReport, loading, error }
}
